/**
 * DeveloperPortal.jsx — /developer
 * Developer AI Tools — paid (ai_tools tier)
 *
 * Tools:
 *   SQL Generator
 *   Regex Generator
 *   API Docs Generator
 *   Cron Generator
 *   API Tester
 *   Meeting Notes Summarizer
 */
import React from 'react';
import PortalLayout from './PortalLayout';

import { MeetingNotes, SQLGenerator }           from '../AITools';
import { RegexGenerator }         from '../AITools';
import { APIDocsGenerator }       from '../AITools';
import { CronGenerator }          from '../NewAITools';
import { APITester }              from '../NewAITools';
import { MeetingNotesSummarizer } from '../AITools';

const TOOLS = [
  {
    id:        'sql_gen',
    label:     'SQL Generator',
    icon:      '🗄️',
    desc:      'Generate optimised queries',
    component: SQLGenerator,
    badge:     null,
    ai:        true,
  },
  {
    id:        'regex_gen',
    label:     'Regex Generator',
    icon:      '.*',
    desc:      'Write & explain patterns',
    component: RegexGenerator,
    badge:     null,
    ai:        true,
  },
  {
    id:        'api_docs',
    label:     'API Docs',
    icon:      '📖',
    desc:      'Generate API documentation',
    component: APIDocsGenerator,
    badge:     null,
    ai:        true,
  },
  {
    id:        'cron_gen',
    label:     'Cron Generator',
    icon:      '⏰',
    desc:      'Plain English → cron',
    component: CronGenerator,
    badge:     null,
    ai:        true,
  },
  {
    id:        'api_tester',
    label:     'API Tester',
    icon:      '🔌',
    desc:      'Analyse & debug API calls',
    component: APITester,
    badge:     'New',
    ai:        true,
  },
  {
    id:        'meeting_notes',
    label:     'Meeting Notes',
    icon:      '📝',
    desc:      'Summarise meeting notes',
    component: MeetingNotes,
    badge:     null,
    ai:        true,
  },
];

const OTHER_PORTALS = [
  { label: '🎯 Job Search', path: '/job-search' },
  { label: '💼 Freelancer', path: '/freelancer' },
  { label: '🛠️ Free Tools', path: '/tools'      },
  { label: '🍁 Finance',    path: '/finance'    },
];

export default function DeveloperPortal() {
  return (
    <PortalLayout
      title="Developer AI Tools"
      icon="⌨️"
      color="#2ecc71"
      tagline="Generate SQL · Write regex · Create API docs · Build cron expressions · Debug API calls"
      tools={TOOLS}
      otherPortals={OTHER_PORTALS}
      upgradeDesc="Access all 6 developer AI tools with a 7-day free trial. 5 AI requests/day during trial."
    />
  );
}
